const config = {
   "googleAPIkey_" : "AIzaSyDDOOWC6KFIfqe5f6n5J0DRkYAGuRXVe1M"
}

export default config